import { SelectFuncionario, SelectLocal } from 'global/components/Selects'
import { useStore } from 'store'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import DigitacaoToolbar from './toolbar'

export default function LocaisToolbar() {
    const { view } = useDigitacaoContext()
    const localId = useStore(state => state.locationId)

    return (
        <DigitacaoToolbar>
            <SelectLocal size="small" variant="standard" width={320} />
            {view === 'mensal' && (
                <SelectFuncionario
                    width={320}
                    size="small"
                    variant="standard"
                    localId={localId}
                    button
                    ativos
                />
            )}
        </DigitacaoToolbar>
    )
}
